import { Icon, Intent, Position, ProgressBar, Toaster } from "@blueprintjs/core"
import axios from "axios"
import useAuth from "hooks/useAuth"
import React, { useState } from "react"
import AppToaster from "utils/AppToaster"
import { useHost } from "../../global/host.global"
import CustomDialog from "../Atoms/CustomDialog"
import CustomFileInput from "../Atoms/CustomFileInput"
import { withFormController } from "./FormController"
const CancelToken = axios.CancelToken
const source = CancelToken.source()
const UploadToast = Toaster.create({
  className: "recipe-toaster",
  position: Position.TOP,
})

const FileUpload = ({
  foldername,
  path,
  value,
  onChange,
  label,
  title,
  dialogProps,
  multiple = true,
  accept,
  ...otherProps
}) => {
  const { token } = useAuth()

  const [file, changeFile] = useState({})
  const [isPreviewOpen, togglePreviewDialog] = useState(false)
  const [isUploaded, changeUploaded] = useState(false)
  const { protocol, host, subdomain } = useHost()
  const link = `${protocol}://${host}/services/uploader/`
  const handleChange = async ({ target: { files } }) => {
    const currentFile = files[0]
    if (currentFile) changeFile(currentFile)
    const form = new FormData()
    form.append("file", currentFile)

    const filePath = [
      subdomain,
      process.env.REACT_APP_ENV,
      "fms-dash",
      foldername,
    ]
      .filter(value => value)
      .join("/")

    form.append("path", filePath)
    try {
      const response = await axios.post(link, form, {
        cancelToken: source.token,
        onUploadProgress: ({ total, loaded }) => {
          const progress = loaded / total
          const percentage = Math.floor(progress * 100)
          UploadToast.show(
            {
              icon: "cloud-upload",
              message: (
                <>
                  <small>{currentFile?.name}</small>
                  <ProgressBar
                    className="vt-file-upload-progress"
                    intent={percentage < 100 ? Intent.PRIMARY : Intent.SUCCESS}
                    value={percentage / 100}
                  />
                </>
              ),
              onDismiss: didTimeoutExpire => {
                if (!isUploaded && !didTimeoutExpire) {
                  source.cancel("Upload of file cancelled by user")
                }
              },

              timeout: percentage < 100 ? 0 : 3000,
            },
            currentFile?.name
          )
        },

        headers: {
          Tenant: subdomain,
          Authorization: `Bearer ${token}`,
        },
      })

      if (response.data.status === "success") {
        onChange(path, response?.data?.url)
        AppToaster.show({
          message: (
            <span>
              Image Uploaded Successfully!{" "}
              <a href={response?.data?.url} target="__blank">
                View
              </a>
            </span>
          ),
          intent: "success",
        })
        changeUploaded(true)
      }
    } catch (err) {
      changeFile({})
      changeUploaded(false)
      onChange(path, null)
      AppToaster.show({
        message: err.message,
        intent: "danger",
      })
    }
  }

  return (
    <>
      <CustomFileInput
        label={
          <div className="flex items-baseline">
            {label}
            {value && (
              <Icon
                style={{
                  cursor: "pointer",
                }}
                className="ml-2"
                icon="mugshot"
                onClick={e => {
                  if (/(.pdf|.xlsx|.csv|.txt)$/i.test(value)) {
                    window.open(value, "__blank")
                  } else {
                    togglePreviewDialog(true)
                  }
                }}
                iconSize={12}
              />
            )}
          </div>
        }
        inputProps={{
          multiple,
          accept,
        }}
        text={file?.name ? file.name : value ? value : "Choose File.."}
        hasSelection={(file && file.name) || value ? true : false}
        onInputChange={handleChange}
        {...otherProps}
      />
      <CustomDialog
        light
        icon="camera"
        scrollable={false}
        title={title ?? "Preview Photo"}
        isOpen={isPreviewOpen}
        onClose={e => togglePreviewDialog(false)}
        {...dialogProps}
      >
        <img
          style={{ width: "100%", height: "100%" }}
          src={value}
          alt={file?.name || value}
        />
      </CustomDialog>
    </>
  )
}

export default withFormController(FileUpload)
